import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';

import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { SaveState } from '../../models/commonModels';

import * as SaleServiceActions from './sale-service.action';
import * as SaleServiceModels from '../../models/sale-service/sale-service';
import { SaleServiceSearchModel } from '../../models/sale-service/sale-serviceSearch';
import { SaleServiceService } from './sale-service.service';
import { SpecificationListSummaryModel } from '../../models/specification/specification';

import { saveAs } from 'file-saver';

export interface SaleServiceStateModel {
    List: SaleServiceModels.SaleServiceListModel;
    Search: SaleServiceSearchModel;
    Save: SaveState;
    SaleService: SaleServiceModels.SaleServiceModel;
    SaleServiceListSummary: SpecificationListSummaryModel;
    FilteredReportLoading: boolean;
  }

@State<SaleServiceStateModel>({
    name: 'saleServiceState',
    defaults: {
      List: null,
      Search: new SaleServiceSearchModel(),
      Save: null,
      SaleService: null,
      SaleServiceListSummary: null,
      FilteredReportLoading: null
    }
  })

  @Injectable()

  export class SaleServiceState {

    constructor(
      private helperService: HelperService,
      private saleServiceService: SaleServiceService,
      private bannerService: BannerService
  ) { }

  @Selector()
  static SaleServiceListSummary(state: SaleServiceStateModel) {
    return state.SaleServiceListSummary;
  }

  @Selector()
  static SaleService(state: SaleServiceStateModel) {
    return state.SaleService;
  }

  @Selector()
  static List(state: SaleServiceStateModel) {
    return state.List;
  }

  @Selector()
  static Save(state: SaleServiceStateModel) {
    return state.Save;
  }

  @Selector()
  static SaleServiceSearch(state: SaleServiceStateModel) {
    return state.Search;
  }

  @Selector()
  static FilteredReportLoading(state: SaleServiceStateModel) {
    return state.FilteredReportLoading;
  }


  @Action(SaleServiceActions.GetList)
  getList(
    context: StateContext<SaleServiceStateModel>,
    action: SaleServiceActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania listy sprzedanych towarów.';

    context.setState(
      patch({
        List: null
      })
    );

    this.saleServiceService.get(action.Search).subscribe((ret) => {
      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );

        return ret;

      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {
        this.helperService.SaveException('SaleServiceActions.GetList', error);

        this.bannerService.error(errorMessage);
      });

  }


  @Action(SaleServiceActions.SetSearch)
  setSearch(
    context: StateContext<SaleServiceStateModel>,
    action: SaleServiceActions .SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new SaleServiceActions.GetList(action.Search));
  }

  @Action(SaleServiceActions.SetListPage)
  setListPage(
    context: StateContext<SaleServiceStateModel>,
    action: SaleServiceActions .SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new SaleServiceActions.GetList(action.Search));
  }

  @Action(SaleServiceActions.ResetSearch)
  resetSearch(
    context: StateContext<SaleServiceStateModel>
  ) {

    const state = context.getState();

    const search = new SaleServiceSearchModel();

    search.ItemsPerPage = state.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search
      }));

    context.dispatch(new SaleServiceActions.GetList(search));
  }

  @Action(SaleServiceActions.GetListSummary)
  getListSummary(
    context: StateContext<SaleServiceStateModel>,
    action: SaleServiceActions.GetListSummary
 ) {

    function patchContext(summary: SpecificationListSummaryModel) {
      context.setState(
        patch({
          SaleServiceListSummary: summary,
        })
      );
    }

    const emptyResponse = new SpecificationListSummaryModel();

    patchContext(null);
    this.saleServiceService.getSummary(action.Search).subscribe ( (summary) => {
      if (summary.Success) {
          patchContext(summary); } else {
              patchContext(emptyResponse);
          }
        },
        (error) => {
            patchContext(emptyResponse);
            this.bannerService.error('Błąd pobierania podsumowania listy usług.');
            this.helperService.SaveException('SaleServiceActions.GetListSummary', error);
    });
  }

  @Action(SaleServiceActions.GetFilteredReport)
  getFilteredReport(
      context: StateContext<SaleServiceStateModel>,
      action: SaleServiceActions.GetFilteredReport
   ) {
        function patchContext( loading: boolean) {
          context.setState(
            patch ({
              FilteredReportLoading: loading
            })
          );
        }

        patchContext(true);
        const fileName = 'Raport-sprzedane-uslugi';
        this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

        this.saleServiceService.getFilteredReport(action.Search).subscribe (
              res => {
                const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                saveAs(file);
                patchContext(false);
              },
              res => {
                patchContext(false);
                this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
              },
              () => {
                patchContext(false);
                this.helperService.consoleLog(' @Action(SaleServiceActions.GetFilteredReport)');
              }
          );
  }

  @Action(SaleServiceActions.DisposeSearch)
  disposeSearch(
      context: StateContext<SaleServiceStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }
}
